import { Modal } from 'antd';
import { rem } from 'polished';
import styled from 'styled-components';

import { BODY_2_REG_2, LABEL_2_REG_2 } from 'src/client/constants/text';

export const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding: 24px 24px 32px;

    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .ant-modal-content {
    border-radius: 8px;

    .ant-modal-close-x {
      padding-top: 12px;
      padding-right: 8px;
    }
  }

  @media ${(props) => props.theme.screen.sm} {
    max-width: 400px;
  }
`;

export const ModalHeading = styled.div`
  display: flex;
  flex-direction: column;

  & > p:last-child {
    max-width: 275px;
    color: ${(props) => props.theme.colors.darkEmphasis2};
  }
`;

export const ModalTip = styled.div`
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 10px;

  border-radius: 4px;
  background: ${(props) => props.theme.colors.neutral6};

  & > p {
    ${BODY_2_REG_2}
  }

  & > p:first-child {
    font-size: ${rem('18px')};
  }
`;

export const RecipientFilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const RecipientTypeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;

  span {
    ${BODY_2_REG_2}
  }
`;

export const RecipientToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    &.ant-switch-checked {
      background-color: ${(props) => props.theme.colors.green500};
    }
  }

  span {
    ${LABEL_2_REG_2}
    color: ${(props) => props.theme.colors.darkEmphasis2};
  }
`;
